<template>
  <div v-if="showModal" class="modal">
    <div class="modal-content">
      <span @click="$emit('close')" class="close">&times;</span>
      <p class="fs-4 bold">[ 입금내역분할 ]</p>

      <div class="text-dark text-start fs-6 mb-2">
        <b>[ 입금정보 <span class="text-secondary" style="font-size: small">({{ this.exDepositNo }})</span> ] </b>
      </div>
      <table class="table table-bordered border-secondary align-middle w-100 h-auto text-center" style="font-size: smaller;">
        <thead>
          <tr class="table-secondary border-secondary">
            <th class="col-1">입금일</th>
            <th class="col-2">입금자</th>
            <th class="col-2">입금액 (원)</th>
            <th class="col-3">입금내역</th>
            <th class="col-1">입금은행</th>
            <th class="col-4">메모사항</th>
          </tr>
          <tr>
            <td>
              {{this.getDateFormat(this.exdepositInfo.depositDate) }}
            </td>
            <td>
              {{ this.exdepositInfo.depositor }}
            </td>
            <td>
              {{ this.getCurrencyFormat(this.exdepositInfo.depositAmt) }}
            </td>
            <td>
              {{ this.exdepositInfo.depositDetail }}
            </td>
            <td>
              {{ this.exdepositInfo.finName }}
            </td>
            <td>
              {{ this.exdepositInfo.depositMemo }}
            </td>
          </tr>
        </thead>
      </table>

      <div class="text-primary text-start fs-6 mb-2">
          <b>[ 행사검색 ]</b> &nbsp;&nbsp;<i style="font-size: small;">※분할가능잔액: <b class="text-danger">{{ this.getCurrencyFormat(this.disibleDepositAmt) }}</b>원</i>
      </div>
      <table class="table table-bordered border-success w-100 h-auto text-center" style="font-size: smaller">
        <tbody>
          <tr>
            <th class="table-primary col-md-1 align-middle">
              행사명
            </th>

            <!-- 행사검색 (담당자/행사명LIKE/행사기간) -->
            <td class="col-md-7" v-if="this.viewSimpleSplit === 'N'">
              <div class="d-flex flex-wrap gap-1 mb-1">
                <select v-model="searchCond.dealChargeId" class="form-select form-select-sm" style="width:20%">
                  <option value="">담당자 전체</option>
                  <option v-for="h in handlerList" :key="h.handlerId" :value="h.handlerId">{{ h.handlerNameKor }}</option>
                </select>
                <input v-model="searchCond.dealNameKor" @keyup.enter="searchDeal" type="text"
                      class="form-control form-control-sm" style="width:25%" placeholder="행사명(LIKE 검색)" />
                <input v-model="searchCond.startDate" type="date" class="form-control form-control-sm" style="max-width:135px" />
                <span class="align-self-center">~</span>
                <input v-model="searchCond.endDate" type="date" class="form-control form-control-sm" style="max-width:135px" />
                <button type="button" class="btn btn-primary btn-sm" @click="searchDeal">검색</button>
                <span style="font-size:small; color:darkolivegreen">※ 정산완료된 행사는 검색제외 / 행사기간은 선택사항</span>
              </div>

              <div class="autocomplete" v-if="result && result.length > 0">
                <div class="text-start" style="cursor: pointer" :key="i" v-for="(res,i) in result" @click="searchDealData(res)">
                  <div class="mt-2">&nbsp;&nbsp;
                    <span style="color:darkblue">{{ res.dealNameKor }}</span>
                    <span style="color:darkgray; font-size:smaller">({{ res.dealCode }})</span>
                    <span style="color:gray; font-size:smaller"> - {{ res.dealChargeName }}</span>
                    <span :style="{ color: res.newFlagTag === '구정산' ? 'blue' : res.newFlagTag === '신정산' ? 'red' : 'red', fontSize: 'smaller' }"> - {{ res.newFlagTag }}</span>
                  </div>
                </div>
              </div>
            </td>

            <!-- 구정산 -->
            <td class="col-md-4 fs-6 text-success" v-if="(this.viewSplit === 'Y' && this.viewSimpleSplit === 'N') && (this.dealNewFlag === 'N' || this.dealNewFlag === '' || !this.dealNewFlag)">
              <div class="d-flex align-items-between">
                <div>
                  [ 금액분할 ] &nbsp;&nbsp;&nbsp;&nbsp;
                </div>
                <div class="form-check form-switch justify-content-end">
                  <input class="form-check-input align-bottom" type="checkbox" role="switch" id="total" v-model="this.totalCheck" true-value="Y" false-value="N">
                  <label class="form-check-label" for="total" style="font-size: small; color:blue">전액({{ this.totalCheck }})</label>
                </div>
              </div>
              <div class="mt-1 input-group">
                <input type="text" v-model="this.splitDepositAmt" class="form-control text-end text-small w-auto">&nbsp;
                <button type="button" class="btn btn-outline-danger btn-sm" @click="depositSplit(this.dealCode,'GS');">분할입력</button>
              </div>

              <div class="mt-1 d-flex gap-2">
                <input type="text" v-model="dcustName" class="form-control resize-input" placeholder="고객명(40자 이내)" style="font-size: smaller; width: 30%;" maxlength="40">
                <input type="text" v-model="splitMemo" class="form-control resize-input" placeholder="메모사항(200자 이내)" style="font-size: smaller; width: 70%;" maxlength="200">
              </div>
            </td>

            <!-- 단순분할(엑셀 일괄) - 기존 유지, 이번 작업에서 미변경 -->
            <!-- <td class="col-md-4 fs-6 text-success" v-if="this.viewSimpleSplit === 'Y'">
              <div class="d-flex align-items-between">
                <div>
                  [ 단순분할 ] &nbsp;&nbsp;&nbsp;&nbsp;
                </div>
              </div>
              <div class="mt-1 input-group">
                <input type="text" v-model="this.splitDepositAmt" class="form-control text-end text-small w-auto">&nbsp;
                <button type="button" class="btn btn-outline-primary btn-sm" @click="depositSplit('','SS');">단순분할</button>
              </div>

              <div class="mt-1">
                <input type="text" v-model="this.splitMemo" class="form-control resize-input" placeholder="메모사항(200자 이내)" style="font-size: smaller;" maxlength="200">&nbsp;
              </div>
            </td> -->
          </tr>
        </tbody>
      </table>

      <!-- 구정산: 분할내역 -->
      <div class="text-danger text-start fs-6 mb-2" v-if="this.dealNewFlag === 'N' || this.dealNewFlag === '' || !this.dealNewFlag">
        <b>[ 분할내역 ]</b>
      </div>
      <table class="table table-bordered border-secondary align-middle w-100 h-auto text-center" style="font-size: smaller;" v-if="this.dealNewFlag === 'N' || this.dealNewFlag === '' || !this.dealNewFlag">
        <thead>
          <tr class="table-danger border-secondary">
            <th class="col-1">확정</th>
            <th class="col-1">분할액(원)</th>
            <th class="col-3">행사명</th>
            <th class="col-1">분할일자</th>
            <th class="col-1">처리자</th>
            <th class="col-4">메모사항</th>
            <th class="col-1" v-if="this.user.handlerGrade <= 5">-</th>
          </tr>
          <tr :key=i v-for="(es, i) in this.exdepositSplitHistory">
            <td class="text-danger" v-if="es.exFixFlag === 'Y'">Y</td>
            <td class="col-1" style="font-weight: bold; color:red" v-else-if="es.dealStatus === 'SE'">정산마감</td>
            <td v-else></td>

            <td class="text-end">
              {{ this.getCurrencyFormat(es.splitDepositAmt) }}
            </td>

            <td v-if="es.dealCode != '' && es.dealCode != null">
              {{ es.dealName }}
            </td>
            <td v-else-if="(es.dealCode == '' || es.dealCode ==  null) && es.simpleName != undefined">
              {{ es.simpleName }}
            </td>
            <td v-else>
            </td>

            <td>
              {{this.getDateFormat(es.splitDate) }}
            </td>
            <td>
              {{ es.spName }}
            </td>
            <td class="text-start">
              {{ es.splitMemo }}
            </td>
            <td v-if="this.user.handlerGrade <= 5">
              <button type="button" class="btn btn-outline-primary btn-sm me-1" @click="changeFixFlag(es.exSubNo, 'Y', es.dealCode)">
                <small><small>확정</small></small>
              </button>
              <button type="button" class="btn btn-outline-danger btn-sm me-1" @click="changeFixFlag(es.exSubNo, 'N', es.dealCode)">
                <small><small>취소</small></small>
              </button>
            </td>
          </tr>
        </thead>
      </table>

      <!-- 신정산: 판매내역 -->
      <div class="text-success text-start fs-6 mb-2" v-if="this.dealNewFlag === 'Y'">
        <div class="d-flex gap-2">
          <span style="font-weight: 600; font-size: 1rem; width: auto;">[ 판매내역 ]</span>
          <select class="form-select form-select-sm resize-select" style="width: 200px;" v-model="this.sa_channelCode" ref="channelCode">
            <option value="all">판매수단전체</option>
            <option :value="sch.pCode" :key="i" v-for="(sch,i) in this.saleChInfo">[{{ sch.pCode }}] {{ sch.pName }}</option>
          </select>
          <input type="text"  class="text-success mb-1 resize-input" style="width: 300px;" v-model="custName" maxlength="40" ref="custName" placeholder="고객명(40자까지)">
          <button type="button" class="btn btn-success btn-sm" @click="searchCustName">검색</button>
        </div>
      </div>
      <table class="table table-bordered border-secondary align-middle w-100 h-auto text-center sales-history-table" style="font-size: smaller;" v-if="this.dealNewFlag === 'Y'">
        <thead>
          <tr class="table-success border-secondary">
            <th style="width: 2%" >-</th>
            <th style="width: 8%" >고객명</th>
            <th style="width: 9%" >채널명</th>
            <th style="width: 3%" >인원</th>
            <th style="width: 5%" >판매가</th>
            <th style="width: 5%" >판매수수료</th>
            <th style="width: 5%" >총판매가</th>
            <th style="width: 5%" >입금액</th>
            <th style="width: 15%">메모사항</th>
            <th style="width: 5%" >미수/과오납</th>
            <th style="width: 4%" >입금</th>
          </tr>
          <template :key="s" v-for="(sh, s) in this.salesHistoryInfo">
            <tr>
              <td>{{ s+1 }}</td>
              <td>
                {{ sh.sa_cusName }}
              </td>
              <td>
                {{ sh.pName }} ({{ sh.sa_dSaleChCode }})
              </td>
              <td>
                {{ sh.sa_cusCnt }}
              </td>
              <td>
                {{ this.getCurrencyFormat(sh.sa_dSalePrice) }}
              </td>
              <td>
                {{ this.getCurrencyFormat(sh.sa_dSaleFee) }}
              </td>
              <td class="text-danger fw-bold">
                {{ this.getCurrencyFormat(sh.sa_dSalePrice-sh.sa_dSaleFee) }}
              </td>
              <td>
                <input type="number" v-model="sh.sa_payAmt" min="0" ref="sa_payAmt" class="resize-input" :disabled="hasExistingPayment(sh.sa_dSubNo)">
                <p class="mt-2 text-secondary text-sm-end">
                  {{ this.getCurrencyFormat(sh.sa_payAmt) }}
                </p>
                <button type="button" class="btn btn-link btn-sm p-0" style="font-size:x-small" @click="showPayHistory(sh.sa_dSubNo, s)">
                  입금이력 <i class="bi" :class="payHistoryRowIndex === s ? 'bi-caret-up-fill' : 'bi-caret-down-fill'"></i>
                </button>
              </td>
              <td>
                <textarea class="form-control resize-input" placeholder="300자 이내" ref="sa_dSaleMemo" v-model="sh.sa_dSaleMemo" maxlength="300"></textarea>
              </td>
              <td :class="{'text-primary': (sh.sa_payAmt - (sh.sa_dSalePrice - sh.sa_dSaleFee)) > 0, 'text-danger' : (sh.sa_payAmt - (sh.sa_dSalePrice - sh.sa_dSaleFee)) < 0}">
                {{ this.getCurrencyFormat(sh.sa_payAmt - (sh.sa_dSalePrice - sh.sa_dSaleFee)) }}
              </td>
              <td>
                <button type="button" class="btn btn-outline-primary btn-sm m-0" @click="depositPay(this.dealCode, sh.sa_dSubNo,'AL')" :disabled="hasExistingPayment(sh.sa_dSubNo)">전액</button>
                <button type="button" class="btn btn-outline-success btn-sm m-0" @click="depositPay(this.dealCode, sh.sa_dSubNo,'PA')" :disabled="hasExistingPayment(sh.sa_dSubNo)">부분</button>
                <button type="button" class="btn btn-outline-danger  btn-sm m-0" @click="depositPay(this.dealCode, sh.sa_dSubNo,'CX')" :disabled="!hasExistingPayment(sh.sa_dSubNo)">취소</button>
              </td>
            </tr>
            <!-- 입금이력 펼침행 -->
            <tr v-if="payHistoryRowIndex === s">
              <td colspan="11">
                <table class="table table-sm table-bordered mb-0" style="font-size:x-small">
                  <thead class="table-light">
                    <tr>
                      <th>입금코드</th>
                      <th>입금일자</th>
                      <th>금액</th>
                      <th>처리일</th>
                      <th>처리자</th>
                      <th>상태</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="payHistoryInfo.length === 0">
                      <td colspan="5" class="text-secondary">입금이력이 없습니다.</td>
                    </tr>
                    <tr :key="p" v-for="(ph, p) in payHistoryInfo" :class="{'text-danger': ph.payUseFlag === 'N'}">
                      <td>{{ ph.exDepositNo }} <span class="text-secondary">(#{{ ph.exSubNo }})</span></td>
                      <td>{{ getDateFormat(ph.depositDate) }}</td>
                      <td class="text-end">{{ getCurrencyFormat(ph.payAmt) }}</td>
                      <td>{{ getDateFormat(ph.payDate) }}</td>
                      <td>{{ ph.payHandlerName }}</td>
                      <td>{{ ph.payStatusTag }}</td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </template>
        </thead>
      </table>
    </div>
  </div>
</template>

<script>
import * as XLSX from 'xlsx'
import moment from 'moment'

export default {
  props: ['showModal', 'modalContent'],
  data() {
    return {
      exdepositInfo: [],          //입금내역정보
      exdepositSplitHistory: [],  //입금분할내역
      exDepositNo: "",            //내역코드
      dealName: "",               //행사제목

      result: null,                //행사명 검색결과

      viewSplit: "N",              //분할창 표시여부

      dealCode: "",                //행사코드
      splitDepositAmt: 0,          //분할액
      dDepositor: "",              //입금자
      splitMemo: "",               //분할메모

      totalCheck: "N",             //전액분할플래그
      viewSimpleSplit: "N",        //단순분할표시플래그

      disibleDepositAmt: 0,        //분할가능한데파짓잔액

      depCode: "",                 //입금처코드
      arr_excelUpData: [],         //축차저장된 엑셀업로드데이타 (일괄단순분할용, 기존유지)

      //신정산프로세스
      searchCond: {
        dealChargeId: "",
        dealNameKor: "",
        startDate: "",
        endDate: "",
      },
      handlerList: [],                  // 담당자 드롭다운용
      dealNewFlag: "",                  // 선택된 행사의 신정산여부
      dcustName: "",                    // 고객명(GS 분할용)

      salesHistoryInfo: [],             // 판매내역리스트
      saleChInfo:  [],                  // 판매수단리스트
      sa_channelCode: "all",            // 판매수단코드
      custName: "",                     // 고객명(검색용)
      salesHistoryInfoOriginal: [],     // 판매내역리스트 원본 (입금처리 delta 계산 기준)

      payHistoryRowIndex: null,         // 펼쳐진 판매내역 행 인덱스 (입금이력)
      payHistorySubNo: null,            // 현재 펼쳐진 입금이력의 판매건 서브넘버 (재조회 판단용)
      payHistoryInfo: [],               // 해당 판매건의 입금이력 (여러 exDepositNo에서 나눠 들어온 내역)
    }
  },
  created() {
    this.user = this.$store.state.user

    this.exDepositNo = this.modalContent
    this.getExdepositInfo()
    this.getHandlerList()

    let today_tmp = moment();
    let today1 = moment([today_tmp.year(), today_tmp.month(), today_tmp.date()]);
    this.today = today1.format("YYYY-MM-DD")
  },
  watch: {
    //부모에서 넘어오는 props와 로컬변수 동기화
    modalContent(newVal)
    {
      this.exDepositNo = newVal
    },

    //전액분할여부추적
    totalCheck(newVal)
    {
      if(newVal === 'Y')
      {
        this.splitDepositAmt = this.exdepositInfo.depositAmt
      }
      else
      {
        this.splitDepositAmt = 0
      }
    }
  },
  methods: {
    //mixins 공통함수
    getDateFormat(date)
    {
      return this.$dateFormat(date);
    },
    getCurrencyFormat(value)
    {
      return this.$currencyFormat(value);
    },
    getDeCurrencyFormat(value)
    {
      return this.$deCurrencyFormat(value);
    },
    getDayOfWeekFormat(text)
    {
      return this.$dayOfWeekFormat(text);
    },
    getNumberOfWeekFormat(text)
    {
      return this.$numberOfWeekFormat(text);
    },

    // 담당자 목록 (드롭다운용)
    async getHandlerList() {
      let handlerList = await this.$api("/api/handlerInfo", {param: []})
      if(handlerList.length > 0) this.handlerList = handlerList
    },

    // 행사 정밀검색 (담당자/행사명LIKE/행사기간)
    async searchDeal() {
      let eUseFlag = "Y"
      let result = await this.$api("/api/getDealInfoSearch", {param: [
        eUseFlag,
        this.searchCond.dealChargeId, this.searchCond.dealChargeId,
        this.searchCond.dealNameKor, this.searchCond.dealNameKor,
        this.searchCond.startDate, this.searchCond.startDate,
        this.searchCond.endDate, this.searchCond.endDate,
      ]})
      this.result = result || []
    },

    // 정산용행사검색 (선택)
    searchDealData(res){
      this.viewSplit = "Y"
      this.dealCode = res.dealCode
      this.dealNewFlag = res.newFlag

      // 신정산의 경우, 판매내역리스트/판매수단 가져온다
      if(this.dealNewFlag === 'Y')
      {
        this.getPartnerList()
        this.getDepositInfo(this.dealCode)
      }
    },

    // 판매내역검색 (고객명/판매수단)
    searchCustName(){
      const source = this.salesHistoryInfoOriginal
      const keyword = this.custName.trim().toLowerCase()

      if(this.sa_channelCode != "all" && keyword != "")
      {
        this.salesHistoryInfo = source.filter((item) => {
          return item.sa_cusName.toLowerCase().includes(keyword) && item.sa_dSaleChCode === this.sa_channelCode
        })
      }
      else if(this.sa_channelCode != "all" && keyword == "")
      {
        this.salesHistoryInfo = source.filter((item) => {
          return item.sa_dSaleChCode === this.sa_channelCode
        })
      }
      else if(this.sa_channelCode == "all" && keyword != "")
      {
        this.salesHistoryInfo = source.filter((item) => {
          return item.sa_cusName.toLowerCase().includes(keyword)
        })
      }
      else
      {
        this.salesHistoryInfo = [...source]
      }
    },

    // 판매수단 리스트
    async getPartnerList() {
      let partnerInfo_tmp = await this.$api("/api/partnerInfo", {});

      //거래중지된 판매수단 제외
      let saleChInfo = partnerInfo_tmp.filter((item) => {
        return (item.saleChFlag === 'Y' && item.pUseFlag === 'Y')
      })

      if(saleChInfo.length > 0)
      {
        this.saleChInfo = saleChInfo
      }
    },

    // 판매건별 입금이력 펼치기/접기 (여러 exDepositNo에서 나눠 들어온 내역 확인용)
    async showPayHistory(subNo, index) {
      if(this.payHistoryRowIndex === index)
      {
        this.payHistoryRowIndex = null
        this.payHistorySubNo = null
        return
      }
      await this.loadPayHistory(subNo, index)
    },

    // 입금이력 조회 (펼칠 때 + 입금처리 후 갱신할 때 공용)
    async loadPayHistory(subNo, index) {
      this.payHistoryRowIndex = index
      this.payHistorySubNo = subNo
      this.payHistoryInfo = []

      let payHistoryInfo = await this.$api("/api/getDealHistoryPay_s", {param: [ this.dealCode, subNo ]})
      if(payHistoryInfo.length > 0) this.payHistoryInfo = payHistoryInfo
    },

    // 이미 입금처리된 판매건인지 확인 (원본 서버데이터 기준) - 전액/부분 버튼 비활성화, 취소 버튼 활성화 제어용
    // 입금액이 있는 건은 재분할(전액/부분) 불가 -> 반드시 취소 후 재입력하도록 강제하여 완전상쇄(+N/-N) 외의 조각난 상계 케이스 발생을 원천 차단
    hasExistingPayment(subNo){
      let original = this.salesHistoryInfoOriginal.find(item => item.sa_dSubNo === subNo)
      return !!(original && parseFloat(original.sa_payAmt) > 0)
    },

    // 판매내역 입금처리 (전액/부분/취소) - 신정산프로세스, 즉시저장
    // 기준: 총판매가 = sa_dSalePrice - sa_dSaleFee (거래처 입금 시 수수료 차감 관행 반영)
    async depositPay(dealCode, subNo, payType){
      let target = this.salesHistoryInfo.find(item => item.sa_dSubNo === subNo)
      if(!target) return

      //이미 입금처리된 건은 전액/부분 재시도 불가 - 취소 후 재시도해야 함 (버튼은 비활성화되어 있지만 방어코드로 이중체크)
      if((payType === 'AL' || payType === 'PA') && this.hasExistingPayment(subNo))
      {
        this.$swal.fire("", "이미 입금처리된 판매건입니다.<br>취소 후 다시 진행해주세요.", "warning")
        return
      }

      // 서버에 이미 반영되어있던 기존 누적입금액 (v-model로 화면입력값이 덮어써지기 전 원본)
      let original = this.salesHistoryInfoOriginal.find(item => item.sa_dSubNo === subNo)
      let oldPayAmt = original ? original.sa_payAmt * 1 : 0

      let totalSalePrice = target.sa_dSalePrice - target.sa_dSaleFee   // 총판매가(판매액-수수료) - 입금기준액
      let targetPayAmt = 0
      let confirmMsg = ""
      let iconType = "question"

      if(payType === 'AL')
      {
        targetPayAmt = totalSalePrice
        confirmMsg = "전액입금(" + this.getCurrencyFormat(targetPayAmt) + "원) 처리하시겠습니까?"
      }
      else if(payType === 'PA')
      {
        targetPayAmt = target.sa_payAmt * 1

        if(!targetPayAmt || targetPayAmt <= 0)
        {
          this.$swal.fire("", "입금처리할 금액을 입력해주세요.", "warning")
          return
        }

        if(targetPayAmt > totalSalePrice)
        {
          confirmMsg = "입력하신 금액(" + this.getCurrencyFormat(targetPayAmt) + "원)이 총판매가를 초과합니다.<br>과오납으로 처리하시겠습니까?"
          iconType = "warning"
        }
        else
        {
          confirmMsg = "부분입금(" + this.getCurrencyFormat(targetPayAmt) + "원) 처리하시겠습니까?"
        }
      }
      else if(payType === 'CX')
      {
        targetPayAmt = 0
        confirmMsg = "입금취소 처리하시겠습니까? (누적입금액이 0원으로 상계됩니다)"
        iconType = "warning"
      }

      let delta = targetPayAmt - oldPayAmt

      // 분할가능잔액 초과 체크 (GS/SS의 disibleDepositAmt 체크와 동일한 원칙)
      if(delta > this.disibleDepositAmt)
      {
        this.$swal.fire("", "이 금액은 현재 입금건의 분할가능잔액(" + this.getCurrencyFormat(this.disibleDepositAmt) + "원)을 초과합니다!", "warning")
        return
      }

      let confirm = await this.$swal.fire({
        html: confirmMsg,
        icon: iconType,
        showCancelButton: true,
        confirmButtonText: "확인",
        cancelButtonText: "취소"
      })
      if(!confirm.isConfirmed) return

      let param = "DS"
      let simpleName = ""
      let dFlag = "D"
      let dCurCd = "KRW"
      let dExRate = 1
      let dPayMethod = "Bank"
      let finCd = this.exdepositInfo.finCd
      let dPayCode = finCd
      let dFeeRate = 0
      let dUseFlag = "Y"
      let splitFlag = "Y"
      let exUseFlag = "Y"

      let res = await this.$api("/api/proc_createExdepositSplit", {param: [
        param, simpleName,
        this.exDepositNo, dealCode, 0, this.user.handlerId, exUseFlag, target.sa_dSaleMemo, finCd, this.user.handlerId,
        dFlag, dCurCd, dExRate, 0, dPayMethod, dPayCode, dFeeRate, target.sa_dSaleMemo, this.exdepositInfo.depositor, this.getDateFormat(this.exdepositInfo.depositDate), dUseFlag,
        splitFlag, target.sa_cusName, subNo, targetPayAmt, payType
      ]})

      if(Object.keys(res)[0] === "error")
      {
        this.$swal.fire("", "입금처리 실패(" + res.error.sqlMessage + ")", "error")
      }
      else
      {
        this.$swal.fire("", "입금처리가 완료되었습니다.", "success")
        // 모달을 닫지 않고 필요한 데이터만 갱신 (분할가능잔액 + 판매내역리스트)
        await this.getExdepositInfo()
        await this.getDepositInfo(dealCode)
        // 지금 처리한 판매건의 입금이력이 펼쳐져있었다면 그것만 최신화
        if(this.payHistorySubNo === subNo && this.payHistoryRowIndex !== null)
        {
          await this.loadPayHistory(subNo, this.payHistoryRowIndex)
        }
      }
    },

    //판매내역리스트
    async getDepositInfo(dealCode){
      let salesHistoryInfo = await this.$api("/api/getDealHistory_sale", {param:[ dealCode ]})

      if(salesHistoryInfo.length > 0)
      {
        this.salesHistoryInfo = salesHistoryInfo
        this.salesHistoryInfoOriginal = JSON.parse(JSON.stringify(this.salesHistoryInfo))
      }
      else
      {
        this.salesHistoryInfo = []
        this.salesHistoryInfoOriginal = []
      }
    },

    //입금내역정보
    async getExdepositInfo(){
      //외부입금기록정보(분할내역)
      let exdepositInfo = await this.$api("/api/getExdepositInfo", {param:[ this.exDepositNo ]})

      if(exdepositInfo.length > 0)
      {
        this.exdepositInfo = exdepositInfo[0]
      }

      //입금분할내역
      let exdepositSplitHistory = await this.$api("/api/getExdepositSplitHistory", {param:[ this.exDepositNo ]})

      if(exdepositSplitHistory.length > 0)
      {
        //분할가능잔액계산 - 완전상쇄쌍은 합이 0이라 원본 전체 합계로 계산해도 결과 동일. 계산/표시 로직을 분리하기 위해 원본 배열 기준으로 처리
        let i = 0
        let sumOfexDepositAmt = 0

        while(i < exdepositSplitHistory.length)
        {
          exdepositSplitHistory[i].splitDepositAmt = Math.trunc(exdepositSplitHistory[i].splitDepositAmt)
          sumOfexDepositAmt += exdepositSplitHistory[i].splitDepositAmt
          i++
        }

        this.disibleDepositAmt = this.exdepositInfo.depositAmt*1 - sumOfexDepositAmt*1

        //화면([구정산: 분할내역] 테이블)에는 완전상쇄된 +/- 쌍을 제외한 목록만 노출
        this.exdepositSplitHistory = this.filterOffsettingPairs(exdepositSplitHistory)
      }
      else
      {
        this.disibleDepositAmt = this.exdepositInfo.depositAmt*1 - 0
        this.exdepositSplitHistory = []
      }
    },

    //상계(취소/출금)로 정확히 상쇄되는 +/- 쌍을 찾아 화면 표시대상에서 제외 (입금내역리스트 페이지와 동일 로직)
    //- 0원 건은 무조건 제외
    //- 같은 dealCode 내에서 절대값이 정확히 일치하는 +/- 쌍만 완전상쇄로 판단해 둘 다 제외
    //- 절대값이 어긋나는 부분취소 케이스는 발생하지 않는 구조(입금액 있으면 전액/부분 잠금)이므로 별도 처리 불필요
    filterOffsettingPairs(list)
    {
      let filtered = list.filter(e => parseFloat(e.splitDepositAmt) !== 0)

      let grouped = {}
      filtered.forEach(e => {
        let key = e.dealCode || 'NODEAL'
        if(!grouped[key]) grouped[key] = []
        grouped[key].push(e)
      })

      let cancelSet = new Set()

      Object.values(grouped).forEach(group => {
        let posMap = {}
        let negMap = {}

        group.forEach(e => {
          let amt = parseFloat(e.splitDepositAmt)
          let absAmt = Math.abs(amt)
          let target = (amt > 0) ? posMap : negMap
          if(!target[absAmt]) target[absAmt] = []
          target[absAmt].push(e.exSubNo)
        })

        Object.keys(posMap).forEach(absAmt => {
          let posList = posMap[absAmt]
          let negList = negMap[absAmt] || []
          let cancelCount = Math.min(posList.length, negList.length)

          for(let j = 0; j < cancelCount; j++)
          {
            cancelSet.add(posList[j])
            cancelSet.add(negList[j])
          }
        })
      })

      return filtered.filter(e => !cancelSet.has(e.exSubNo))
    },

    //일괄분할처리 (엑셀, 기존 유지)
    handleFileUpload(event) {
      const file = event.target.files[0];

      if(!file) return

      const reader = new FileReader();

      reader.onload = (e) => {
        const data = e.target.result;
        const workbook = XLSX.read(data, { type: 'binary' });
        this.processExcel(workbook);
      };

      reader.readAsBinaryString(file);
    },

    async processExcel(workbook) {
      const firstSheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[firstSheetName];

      let startLine = 0

      const jsonData = XLSX.utils.sheet_to_json(worksheet, {
        raw: false,
        dateNF: 'yyyy-mm-dd HH:MM:SS',
        range: startLine
      });

      if(jsonData.length > 500)
      {
        this.$swal.fire("","일괄입력데이타의 최대값은 500건입니다.", "warning")
        return false
      }
      else
      {
        this.$swal.fire("","데이타의 양에 따라 시간이 소요될 수 있습니다.<br>종료안내까지 대기하세요.", "info")
      }

      let i=0
      let simpleSplitAmt = 0
      let arr_excelUpData = []

      while(i < jsonData.length)
      {
        let excelUpData = {}

        simpleSplitAmt +=(jsonData[i].정산예정금액*1)

        excelUpData.simpleName = jsonData[i].상품명
        excelUpData.splitMemo = jsonData[i].구매자명
        excelUpData.splitDepositAmt = jsonData[i].정산예정금액

        arr_excelUpData.push(excelUpData)
        i++
      }
      this.arr_excelUpData = arr_excelUpData

      if(this.disibleDepositAmt != simpleSplitAmt)
      {
        this.$swal.fire("","업로드된 총액이 입금가능액과 불일치합니다. <br>금액을 체크해주세요","warning")
        return false
      }
      else
      {
        let res = ""

        let param = "SS"
        let dCode = ""
        let exUseFlag = "Y"
        let dFlag = "D"
        let dCurCd = "KRW"
        let dExRate = 1
        let dPayMethod = "Bank"
        let finCd = this.exdepositInfo.finCd
        let dPayCode = finCd
        let dFeeRate = 0
        let dUseFlag = "Y"
        let splitFlag = "Y"

        let j = 0
        while(j < arr_excelUpData.length)
        {
          let ins_simpleSplitInfo = []

          // processExcel - 엑셀 일괄 SS
          ins_simpleSplitInfo = await this.$api("/api/proc_createExdepositSplit", {param: [ param, this.arr_excelUpData[j].simpleName,
            this.exDepositNo, dCode, this.arr_excelUpData[j].splitDepositAmt, this.user.handlerId, exUseFlag, this.arr_excelUpData[j].splitMemo, finCd, this.user.handlerId,
            dFlag, dCurCd, dExRate, this.splitDepositAmt, dPayMethod, dPayCode, dFeeRate, this.arr_excelUpData[j].splitMemo, this.exdepositInfo.depositor, this.getDateFormat(this.exdepositInfo.depositDate), dUseFlag,
            splitFlag, "", null, null, null
          ]})

          if(ins_simpleSplitInfo.affectedRows > 0)
          {
            res = "OK"
          }
          else
          {
            res = "Error"
            break
          }

          j++
        }

        if(res === "error")
        {
          this.$swal.fire('', '처리 중 문제가 발생했습니다.', 'error');
          return false;
        }
        else
        {
          this.$swal.fire('', '일괄단순분할이 완료되었습니다.', 'success');
          location.reload(true);
        }
      }
    },

    //분할확정-취소
    async changeFixFlag(sub, param, dealCode){        //param: Y or N
      let confirmSplitInfo = await this.$api("/api/proc_confirmSplitInfo", {param:[
        this.exDepositNo, param, this.user.handlerId, sub, dealCode
      ]})

      if(confirmSplitInfo.affectedRows < 0 || confirmSplitInfo.affectedRows == undefined)
      {
        this.$swal.fire('', '분할처리의 상태변경(confirmSplitInfo)에 문제가 발생했습니다.', 'error');
        return false;
      }
      else
      {
        this.$swal.fire('', '분할처리의 상태가 변경되었습니다.', 'success');
        location.reload(true);
      }
    },

    simpleSplit(){
      this.viewSimpleSplit = (this.viewSimpleSplit === "Y") ? "N" : "Y"
    },

    //입금액 분할처리 (구정산: GS/SS)
    async depositSplit(dCode, param){
      let exUseFlag = "Y"
      let dFlag = "D"
      let dCurCd = "KRW"
      let dExRate = 1
      let dPayMethod = "Bank"
      let finCd = this.exdepositInfo.finCd
      let dPayCode = finCd
      let dFeeRate = 0
      let dUseFlag = "Y"
      let splitFlag = "Y"
      let simpleName = ""

      let ins_splitInfo = []

      if(this.disibleDepositAmt < this.splitDepositAmt)
      {
        this.splitDepositAmt = 0
        this.$swal.fire("","입력금액은 분할가능한 잔액을 초과할 수 없습니다!", "warning")
        return false;
      }
      else
      {
        if(param === "GS")
        {
          ins_splitInfo = await this.$api("/api/proc_createExdepositSplit", {param: [ param, simpleName,
            this.exDepositNo, dCode, this.splitDepositAmt, this.user.handlerId, exUseFlag, this.splitMemo, finCd, this.user.handlerId,
            dFlag, dCurCd, dExRate, this.splitDepositAmt, dPayMethod, dPayCode, dFeeRate, this.splitMemo, this.exdepositInfo.depositor, this.getDateFormat(this.exdepositInfo.depositDate), dUseFlag,
            splitFlag, this.dcustName, null, null, null
          ]})
        }
        //단순분할
        else if(param === "SS")
        {
          let splitMemo = (this.splitMemo == "") ? "단순분할" : this.splitMemo
          ins_splitInfo = await this.$api("/api/proc_createExdepositSplit", {param: [ param, simpleName,
            this.exDepositNo, dCode, this.splitDepositAmt, this.user.handlerId, exUseFlag, splitMemo, finCd, this.user.handlerId,
            dFlag, dCurCd, dExRate, this.splitDepositAmt, dPayMethod, dPayCode, dFeeRate, splitMemo, this.exdepositInfo.depositor, this.getDateFormat(this.exdepositInfo.depositDate), dUseFlag,
            splitFlag, this.dcustName, null, null, null
          ]})
        }
        if(Object.keys(ins_splitInfo)[0] === "error")
        {
          this.$swal.fire("","등록실패("+ ins_splitInfo.error.sqlMessage +")", "error")
        }
        else {
          this.$swal.fire('','금액분할처리완료', 'success');
          location.reload(true);
        }
      }
    },
  }
}
</script>

<style scoped>
.table_sup td {
  padding: 0;
  overflow-y: auto;
}

.resize-select {
    width: 100%;
    box-sizing: border-box;
    font-size: smaller;
  }

.resize-input {
  width: 100%;
  box-sizing: border-box;
  font-size: smaller;
}

.custom-switch .form-check-input:checked {
    background-color: #007bff;
  }

  .custom-switch .form-check-input:checked+.form-check-label::before {
    background-color: #fff;
  }

  .modal-content {
  background-color: #fff;
  padding: 1rem;
  border-radius: 0.3rem;
  max-height: 80vh;
  overflow-y: auto;
  width: 90vw;
  box-sizing: border-box;
}

.sales-history-table td {
  vertical-align: top;
}

/* 판매내역(전액/부분/취소) 버튼 - 비활성화 시 색상 구분 없이 명확한 회색으로 표시 */
.sales-history-table .btn:disabled {
  color: #adb5bd !important;
  border-color: #ced4da !important;
  background-color: #e9ecef !important;
  opacity: 1;
  cursor: not-allowed;
}
</style>